import React from 'react';
import {CheckBox} from '../../components/Checkbox';
import {
  ClassAndStudents,
  StyledBoxedDropdown,
  CustomOptionList,
  CheckboxItem
} from './Module.page';

export const ClassListAndStudents = (
  classList: {label: string}[],
  selection: string,
  setSelection: React.Dispatch<React.SetStateAction<string>>,
  items: any[],
  allSelected: boolean,
  toggleAll: () => void,
  selectedStudentsCheckBox: string,
  select: (item: any) => void
): any => {
  return (
    <ClassAndStudents>
      <StyledBoxedDropdown
        placeholder={selection}
        label='Klassen'
        optionListProps={{items: classList}}
        defaultValue={selection}
        onSelectionChange={item => {
          setSelection(item.label || 'Keine Klasse ausgewählt');
        }}
      />
      <CustomOptionList
        height={308}
        items={items}
        header={
          <CheckboxItem as='div' active={allSelected}>
            <CheckBox small checked={allSelected} onClick={toggleAll}>
              <strong>{selectedStudentsCheckBox}</strong>
            </CheckBox>
          </CheckboxItem>
        }
        renderItem={(item: any, key) => (
          <CheckboxItem key={key} active={item.active}>
            <CheckBox
              small
              checked={item.active}
              onClick={() => {
                select(item);
              }}
            >
              {item.label} {item.subLabel}
            </CheckBox>
          </CheckboxItem>
        )}
      />
    </ClassAndStudents>
  );
};
